import {
  ApiError,
  parseApiResponseError,
  ApiErrorCodes,
} from '../api/api-error';
import {
  VerificaCambioCellulareError,
  VerificaCambioEmailError,
  VerificaCellulareErrorCodiciErroreEnum,
  VerificaEmailErrorCodiciErroreEnum,
} from '../api/generated';
import {
  VerificationEmailChangeEmailError,
  VerificationPhoneNumberChangePhoneNumberError,
} from '../store';

const getCodiceDiVerificaSbagliatoError = (
  apiError: ApiError<VerificaCambioEmailError | VerificaCambioCellulareError>
):
  | VerificationEmailChangeEmailError
  | VerificationPhoneNumberChangePhoneNumberError => {
  const invalidFields = apiError.payload?.campiNonValidi;
  const attemptsEmail = apiError.payload?.tentativiRimastiOTPEmail;
  const attemptsPhoneNumber = apiError.payload?.tentativiRimastiOTPCellulare;

  if (invalidFields?.length > 0) {
    if (
      ['codiceDiVerificaEmail', 'codiceDiVerificaCellulare'].every((code) =>
        invalidFields.includes(code)
      )
    ) {
      return {
        type: 'CODICE_DI_VERIFICA_SBAGLIATO',
        attemptsEmail,
        attemptsPhoneNumber,
      };
    } else if (invalidFields.includes('codiceDiVerificaEmail')) {
      return {
        type: 'CODICE_DI_VERIFICA_EMAIL_SBAGLIATO',
        attemptsEmail,
        attemptsPhoneNumber
      };
    } else if (invalidFields.includes('codiceDiVerificaCellulare')) {
      return {
        type: 'CODICE_DI_VERIFICA_CELLULARE_SBAGLIATO',
        attemptsPhoneNumber,
        attemptsEmail
      };
    }
    return {
      type: 'CODICE_DI_VERIFICA_SBAGLIATO',
      attemptsEmail,
      attemptsPhoneNumber,
    };
  }

  return { type: 'GENERIC_ERROR' };
};

export const getVerificationEmailOrPhoneNumberError = (
  error: unknown
):
  | VerificationEmailChangeEmailError
  | VerificationPhoneNumberChangePhoneNumberError => {
  const apiError = parseApiResponseError<
    VerificaCambioEmailError | VerificaCambioCellulareError
  >(error);
  const errorCode = apiError.payload?.codiciErrore?.[0];

  if (apiError.responseErrorCode === ApiErrorCodes.BAD_REQUEST && errorCode) {
    switch (errorCode) {
      case VerificaEmailErrorCodiciErroreEnum.CodiceDiVerificaSbagliato:
      case VerificaCellulareErrorCodiciErroreEnum.CodiceDiVerificaSbagliato:
      case VerificaCellulareErrorCodiciErroreEnum.CodiceDiVerificaCellulareSbagliato:
      case VerificaCellulareErrorCodiciErroreEnum.CodiceDiVerificaEmailSbagliato:
        return getCodiceDiVerificaSbagliatoError(apiError);
      case VerificaEmailErrorCodiciErroreEnum.TroppiTentativi:
      case VerificaCellulareErrorCodiciErroreEnum.TroppiTentativi:
        return { type: 'TROPPI_TENTATIVI' };
    }
  }
  return { type: 'GENERIC_ERROR' };
};
